import { SnapInStateDataDto, StateDto } from '../api';
import { DeviceStateValues } from './devices';

export const getStateForZigbee = (
  devicesStates: SnapInStateDataDto[],
  zigbeeId: string
): SnapInStateDataDto => {
  return devicesStates.find(dev => dev.zigbeeId === zigbeeId) || {};
};

export const isActiveDevice = (
  devicesStates: SnapInStateDataDto[],
  zigbeeId: string,
  deviceIndex: number
): boolean => {
  const dvcs = getStateForZigbee(devicesStates, zigbeeId);
  let isActive = false;
  if (dvcs.devices) {
    isActive = dvcs.devices.some(
      el =>
        el.deviceNumber === deviceIndex &&
        el.states.find(state => state.data.state === 'ON')
    );
  }
  return isActive;
};

export const getDeviceStatesByIndex = (
  snapInsState: SnapInStateDataDto[],
  zigbeeId: string,
  deviceIndex: number
): StateDto[] => {
  const zigbeeState = getStateForZigbee(snapInsState, zigbeeId);
  return zigbeeState.devices.find(dev => dev.deviceNumber === deviceIndex)
    .states;
};

export const getDeviceStateIndex = (
  snapInsState: SnapInStateDataDto[],
  zigbeeId: string,
  deviceNumber: number
): number => {
  let deviceStateIndex: number = 0;
  const snapInIndex = snapInsState.findIndex(el => el.zigbeeId === zigbeeId);
  if (snapInsState[snapInIndex].devices) {
    deviceStateIndex = snapInsState[snapInIndex].devices.findIndex(
      dev => dev.deviceNumber === deviceNumber
    );
  }
  return deviceStateIndex;
};

export interface IDeviceSubscriptionState {
  locationId: string;
  zigbeeId: string;
  dockNumber: string;
  deviceNumber: number;
  deviceState: StateDto;
}

export const updateDeviceByIndex = (
  snapInsState: SnapInStateDataDto[],
  zigbeeId: string,
  deviceNumber: number,
  setSnapInStates: (snapInState: SnapInStateDataDto[]) => void,
  alwaysOn?: boolean,
  // It also will be working for messages from z2m once if provided
  deviceStateData?: IDeviceSubscriptionState
) => {
  const deviceToChangeIndex = getDeviceStateIndex(
    snapInsState,
    zigbeeId,
    deviceNumber
  );

  const newSnapInsState = [...snapInsState];
  const snapInToChangeIndex = snapInsState.findIndex(
    el => el.zigbeeId === zigbeeId
  );

  if (snapInToChangeIndex !== -1) {
    const stateToChangeIndex = newSnapInsState[snapInToChangeIndex].devices[
      deviceToChangeIndex
    ].states.findIndex(
      state =>
        state.data.state === DeviceStateValues.OFF ||
        state.data.state === DeviceStateValues.ON
    );

    if (stateToChangeIndex !== -1) {
      let newState;
      if (deviceStateData) {
        newState = deviceStateData.deviceState.data;
      } else {
        const changedState = isActiveDevice(
          snapInsState,
          zigbeeId,
          deviceNumber
        )
          ? DeviceStateValues.OFF
          : DeviceStateValues.ON;
        const alwaysActiveState = alwaysOn
          ? DeviceStateValues.ON
          : DeviceStateValues.OFF;
        newState = {
          state: alwaysOn ? alwaysActiveState : changedState
        };
      }

      newSnapInsState[snapInToChangeIndex].devices[deviceToChangeIndex].states[
        stateToChangeIndex
      ].data = newState;
    }
  }

  setSnapInStates(newSnapInsState);
};
